import { Component, Input } from '@angular/core';
import { IconToolTipComponent } from '../../icon-tool-tip/icon-tool-tip.component';
import { MatLabel } from '@angular/material/form-field';
import { TooltipPosition } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-field-label-container',
  standalone: true,
  imports: [CommonModule, IconToolTipComponent, MatLabel],
  templateUrl: './field-label-container.component.html',
  styleUrl: './field-label-container.component.scss',
})
export class FieldLabelContainerComponent {
  @Input({ required: true }) fieldLabel!: string;
  @Input({ required: true }) labelFor!: string;
  @Input() displayTooltip: boolean = false;
  @Input() matTooltipInfo!: string;
  @Input() matTooltipPositionInfo: TooltipPosition = 'above';
}
